export const InterestSettings = {
    UPDATE_INTEREST_SETTINGS: "UPDATE_INTEREST_SETTINGS",
  };